"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var collectedFilters_1 = require("../../../../../../common/service/collectedFilters");
var useCheckoutContext_1 = require("../../../../../common/hooks/useCheckoutContext");
var expressionOfInterestSummaryStyles_1 = require("./expressionOfInterestSummaryStyles");
var ExpressionOfInterestSummary = function () {
    var _a;
    var styles = expressionOfInterestSummaryStyles_1.default();
    var eoi = collectedFilters_1.default().filters.expressionsOfInterest;
    var eoiFilters = (_a = eoi) === null || _a === void 0 ? void 0 : _a.split(',');
    var expressionOfInterest = useCheckoutContext_1.default().expressionOfInterest;
    var selectedItems = react_1.useMemo(function () {
        var selectedCodes = eoiFilters || [];
        var selections = expressionOfInterest.filter(function (item) { return selectedCodes.includes(item.code); });
        return selections;
    }, [expressionOfInterest, eoiFilters]);
    return (<core_1.Box data-test={'checkout4:extras:summary:root'}>
      {selectedItems.map(function (item) { return (<core_1.Typography key={item.code} variant={'body1'} className={styles.item} data-test={"checkout:expressions_of_interest:summary:label:" + item.code}>
          {item.attributes.label}
        </core_1.Typography>); })}
    </core_1.Box>);
};
exports.default = ExpressionOfInterestSummary;
